import { render, staticRenderFns } from "./BreadCrumb.vue?vue&type=template&id=d7604018&lang=pug&"
import script from "./BreadCrumb.vue?vue&type=script&lang=ts&"
export * from "./BreadCrumb.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports